import { useState } from 'react';

export default function useToken() {
  const getToken = () => {
    const tokenString = localStorage.getItem('Authorization');
    console.log("Auth",tokenString)
    const userToken = tokenString;
    return userToken
  };
  const [token, setToken] = useState(getToken());

  const saveToken = userToken => {
    if(userToken){
      localStorage.setItem('Authorization', "Token " + userToken.token);
     
      setToken(userToken.token);
    }
  };
  return {
    setToken: saveToken,
    token,
    getToken: getToken
  }
}